{
  "blocks": [
    {
      "id": "proc-myomectomy",
      "kind": "procedure",
      "tags": ["her", "testing", "pre-cycle"],
      "title": "Myomectomy",
      "subtitle": "Surgical removal of uterine fibroids while preserving the uterus",
      "body": {
        "procedureName": "Myomectomy",
        "category": "diagnostic",
        "description": "Surgical removal of fibroids (leiomyomas) from the uterus while preserving the uterus for future pregnancy. Approach depends on fibroid location: hysteroscopic (inside cavity), laparoscopic (outside/within the wall), or open abdominal for very large or numerous fibroids.",
        "howItWorks": "Submucosal fibroids (inside the cavity) are removed hysteroscopically, a camera through the cervix with no external incisions. Intramural or subserosal fibroids are removed laparoscopically (small incisions) or via open surgery (larger incision). The surgeon carefully dissects fibroids from the uterine muscle and repairs the uterine wall in layers to maintain structural integrity for future pregnancy.",
        "duration": "1-3 hours depending on number, size, and approach",
        "costRange": {
          "low": 5000,
          "high": 20000
        },
        "currency": "USD",
        "anesthesia": "general",
        "painAndComfort": [
          "You will be asleep during surgery; discomfort and recovery depend on whether the approach is hysteroscopic, laparoscopic, or open."
        ],
        "recoveryTime": "Hysteroscopic: 1-2 days. Laparoscopic: 1-2 weeks. Open: 4-6 weeks.",
        "whatToExpect": [
          "Pre-surgical imaging (MRI) to map fibroid locations",
          "Some clinics pre-treat with GnRH agonist to shrink fibroids",
          "Hospital stay: outpatient (hysteroscopic), 1-2 nights (open)",
          "Wait 3-6 months before attempting pregnancy to allow healing",
          "C-section may be recommended if uterine wall was deeply incised"
        ],
        "prepInstructions": [
          "Pre-operative blood work and imaging",
          "Iron supplementation if anemic from heavy bleeding",
          "No food or drink after midnight",
          "Arrange for help at home during recovery"
        ],
        "risks": [
          "Bleeding (may rarely require transfusion)",
          "Infection",
          "Adhesion formation",
          "Fibroid recurrence (20-30% over 5 years)",
          "Uterine rupture risk in future pregnancy if deep myometrial entry (rare)",
          "Very rare: unplanned hysterectomy for uncontrolled bleeding"
        ],
        "forWhom": "her",
        "frBody": {
          "procedureName": "Myomectomie",
          "description": "Ablation chirurgicale des fibromes (léiomyomes) utérins en préservant l'utérus pour une grossesse future. L'approche dépend de la localisation : hystéroscopique (intracavitaire), cœlioscopique (extérieur ou intramural) ou laparotomie pour les fibromes très volumineux ou multiples.",
          "howItWorks": "Les fibromes sous-muqueux (dans la cavité) sont retirés par hystéroscopie : caméra à travers le col, sans incision externe. Les fibromes intramuraux ou sous-séreux sont retirés par cœlioscopie (petites incisions) ou laparotomie (incision plus large). Le chirurgien dissèque délicatement les fibromes du muscle utérin et referme la paroi utérine en plusieurs plans pour préserver son intégrité en vue d'une grossesse future.",
          "duration": "1 à 3 heures selon le nombre, la taille et l'approche",
          "recoveryTime": "Hystéroscopie : 1 à 2 jours. Cœlioscopie : 1 à 2 semaines. Laparotomie : 4 à 6 semaines.",
          "whatToExpect": [
            "Imagerie préopératoire (IRM) pour cartographier les fibromes",
            "Certains centres prescrivent un agoniste de la GnRH au préalable pour réduire la taille des fibromes",
            "Hospitalisation : ambulatoire (hystéroscopie), 1 à 2 nuits (laparotomie)",
            "Attendre 3 à 6 mois avant de tenter une grossesse, le temps de la cicatrisation",
            "Une césarienne peut être recommandée en cas d'incision profonde du muscle utérin"
          ],
          "prepInstructions": [
            "Bilan préopératoire (sang et imagerie)",
            "Supplémentation en fer en cas d'anémie liée aux saignements",
            "À jeun à partir de minuit",
            "Organisez une aide à domicile pendant la convalescence"
          ],
          "risks": [
            "Saignements (transfusion rarement nécessaire)",
            "Infection",
            "Adhérences",
            "Récidive des fibromes (20 à 30 % à 5 ans)",
            "Risque de rupture utérine lors d'une grossesse future en cas d'effraction profonde du myomètre (rare)",
            "Très rare : hystérectomie d'hémostase non planifiée"
          ]
        }
      },
      "sources": [
        {
          "title": "ACOG Practice Bulletin No. 228: Management of Symptomatic Uterine Leiomyomas",
          "authors": "American College of Obstetricians and Gynecologists",
          "journal": "Obstetrics & Gynecology",
          "year": 2021,
          "url": "https://journals.lww.com/greenjournal/fulltext/2021/06000/management_of_symptomatic_uterine_leiomyomas__acog.36.aspx",
          "evidenceLevel": "guideline"
        },
        {
          "title": "AAGL Practice Report: Practice Guidelines for the Diagnosis and Management of Submucous Leiomyomas",
          "authors": "AAGL",
          "journal": "Journal of Minimally Invasive Gynecology",
          "year": 2012,
          "url": "https://pubmed.ncbi.nlm.nih.gov/22381967/",
          "evidenceLevel": "guideline"
        }
      ]
    }
  ],
  "relationships": [],
  "localeVariants": []
}
